'use strict';

module.exports.classic = require('./classic');



//////////////////
// WEBPACK FOOTER
// ./src/schema/index.js
// module id = 30
// module chunks = 0